import { render } from "./GuestDetails.vue?vue&type=template&id=9546e678&scoped=true&bindings={\"openMainBookerState\":\"data\",\"openCompanionState\":\"data\",\"isInsert\":\"data\",\"companionIndex\":\"data\",\"editMainBooker\":\"options\",\"scrollToTop\":\"options\",\"mainBookerSaved\":\"options\",\"addCompanion\":\"options\",\"editCompanion\":\"options\",\"companionSaved\":\"options\",\"deleteCompanion\":\"options\",\"continueToVehicles\":\"options\"}"
import script from "./GuestDetails.vue?vue&type=script&lang=js"
export * from "./GuestDetails.vue?vue&type=script&lang=js"

import "./GuestDetails.vue?vue&type=style&index=0&id=9546e678&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9546e678"

export default script